var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27428 15.4837C7.80215 15.1647 7.47533 14.6989 7.29688 14.0831L8.39269 13.6315C8.49216 14.0105 8.66584 14.3041 8.91376 14.5126C9.1601 14.721 9.4601 14.8237 9.81064 14.8237C10.1691 14.8237 10.477 14.7147 10.7343 14.4968C10.9917 14.2789 11.1212 14.001 11.1212 13.6647C11.1212 13.3205 10.9854 13.0394 10.7138 12.8215C10.4422 12.6036 10.1012 12.4946 9.69378 12.4946H9.06063V11.4099H9.62904C9.97958 11.4099 10.2749 11.3152 10.5149 11.1257C10.7549 10.9362 10.8749 10.6773 10.8749 10.3473C10.8749 10.0536 10.7675 9.81986 10.5527 9.64464C10.338 9.46937 10.0664 9.38096 9.73639 9.38096C9.41426 9.38096 9.1585 9.46623 8.96898 9.63835C8.77951 9.81048 8.64212 10.022 8.5553 10.2715L7.47055 9.8199C7.61422 9.41251 7.87795 9.0525 8.26477 8.74148C8.65163 8.43041 9.14585 8.27408 9.74586 8.27408C10.1895 8.27408 10.589 8.35935 10.9427 8.53147C11.2964 8.7036 11.5743 8.94201 11.7749 9.24516C11.9754 9.5499 12.0749 9.89097 12.0749 10.2699C12.0749 10.6568 11.9817 10.9836 11.7954 11.2521C11.6091 11.5205 11.3801 11.7257 11.1085 11.8695V11.9342C11.467 12.0842 11.7591 12.3131 11.9896 12.6211C12.2186 12.9289 12.3338 13.2969 12.3338 13.7264C12.3338 14.1558 12.2249 14.5395 12.007 14.8758C11.7891 15.2122 11.4875 15.4774 11.1054 15.6701C10.7217 15.8627 10.2906 15.9606 9.81219 15.9606C9.25797 15.9621 8.74642 15.8027 8.27428 15.4837Z",
    fill: "#0085F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0079 10.0468L13.8047 10.9168L13.2031 10.0041L15.3616 8.4473H16.189V15.7911H15.0079V10.0468Z",
    fill: "#0085F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.315 18.3159H5.68319L3.875 20.9802L5.68319 24.0003H18.315L19.8089 20.7871L18.315 18.3159Z",
    fill: "#00A94B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3161 0.00128174H1.89477C0.847891 0.00128174 0 0.849173 0 1.89605V18.3174L2.84218 20.3379L5.68436 18.3174V5.68559H18.3162L20.2607 2.84341L18.3161 0.00128174Z",
    fill: "#0085F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3159V22.1055C0 23.1524 0.847891 24.0003 1.89477 24.0003H5.68431V18.3159H0Z",
    fill: "#00802E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9968 5.68624L21.1546 3.85742L18.3125 5.68624V18.3181L20.8686 19.6523L23.9968 18.3181V5.68624Z",
    fill: "#FFBC00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9968 5.68559V1.89605C23.9968 0.849173 23.1489 0.00128174 22.102 0.00128174H18.3125V5.68559H23.9968Z",
    fill: "#0067D5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3125 24.0003L23.9968 18.3159H18.3125V24.0003Z",
    fill: "#FF4131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCalendarIcon);
export default __webpack_public_path__ + "static/media/GoogleCalendarIcon.015e8171920c43a34426aa926e28fd5a.svg";
export { ForwardRef as ReactComponent };